var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button, InputTextBox } from 'template/lib';
import { useEffect, useState } from 'react';
Modal.setAppElement('#root');
var ModalEditLicenses = function (_a) {
    var handleOpenModalEdit = _a.handleOpenModalEdit, handleCloseModalEdit = _a.handleCloseModalEdit, idItem = _a.idItem, detalhe = _a.detalhe;
    var login = useAuth().login;
    var config = { headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) } };
    var _b = useState(false), alertOpen = _b[0], setAlertOpen = _b[1];
    /* ==========================
       🔧 FORMik
    ========================== */
    var formik = useFormik({
        initialValues: {
            detalhe: detalhe || ''
        },
        enableReinitialize: true,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                api.put("/licenses/" + idItem + "/renovationDetails", {
                    renovationDetails: values.detalhe
                }, config)
                    .then(function () {
                    console.log('Atualizado com sucesso');
                    handleCloseModalEdit();
                })
                    .catch(console.error);
                return [2 /*return*/];
            });
        }); }
    });
    /* ==========================
       🔧 BUSCA USUÁRIOS
    ========================== */
    useEffect(function () {
        if (!alertOpen)
            return;
        var timer = setTimeout(function () { return setAlertOpen(false); }, 15000);
        return function () { return clearTimeout(timer); };
    }, [alertOpen]);
    /* ==========================
       RENDER
    ========================== */
    return (_jsx(Modal, __assign({ isOpen: handleOpenModalEdit, shouldCloseOnOverlayClick: false, onRequestClose: handleCloseModalEdit, overlayClassName: "react-modal-overly", className: "react-modal-content", contentLabel: "Editar Detalhes da Licen\u00E7a" }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: "font-semibold border-b-2 text-lg" }, { children: "Detalhes da Licen\u00E7a" }), void 0), _jsx(AiOutlineClose, { title: "Fechar", className: "cursor-pointer text-sm", onClick: function () {
                                handleCloseModalEdit();
                                formik.resetForm();
                            } }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: "mx-4 my-4" }, { children: [_jsx("div", __assign({ className: "grid justify-items-start" }, { children: _jsx("div", __assign({ className: "grid grid-cols-3 justify-items-end" }, { children: _jsx(InputTextBox, { onChange: formik.handleChange, inicialValue: formik.values.detalhe, width: "100%", height: "18rem", name: "detalhe", label: "Detalhes" }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-4 flex justify-end" }, { children: _jsx(Button, __assign({ type: "submit" }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0));
};
export default ModalEditLicenses;
